// @ts-check
import Header from "../../modules/header/header-client";

Header.init(window.tracker);
